export default function Microskills() {
  return (
    <>
      <h2 className="text-4xl font-extrabold mb-4">Microskills</h2>
      <p className="text-gray-700 mb-4">
        A microskill is the smallest unit of measurable, repeatable understanding. Instead of vaguely
        learning “calculus” or “accounting,” you’ll identify the building blocks — and train directly on them.
      </p>
      <p className="text-gray-700">
        Each Mindzera microskill is delivered as a testable item. You either get it right, or you don’t.
        Mastery comes from focused practice and precise feedback, not passive reading.
      </p>
    </>
  );
}
